import {Server} from "@/common/server/server";
import * as i18n from '!!@green-code-studio/internationalization/i18nWebpackLoader!../../../Translations/i18n.xml';

export const Translator = {
    currentLanguage: 'pl',//default
    translate(name) {
        try {
            return i18n.t(name)
        }catch(e){
            console.warn('lack translation', name,e)
            return name;
        }
    },
    changeLanguage(lang) {
        console.log('Changing language to ', lang);
        i18n.translator.languageHierarchy.langs = [lang]
        this.currentLanguage = lang
        this.setHtmlLang();
    },
    setHtmlLang() {
        document.documentElement.lang = this.currentLanguage;
    }
}
